import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "human-pain",
  "use": "human-pain-usage",
  "viewBox": "0 0 71 15",
  "content": "<symbol viewBox=\"0 0 71 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"human-pain\"><path d=\"M0 14H13.3811C17.2671 14 20.6384 11.3167 21.5103 7.52976V7.52976C22.3822 3.74281 25.7535 1.05951 29.6395 1.05951H38.1619C44.0213 1.05951 49.3644 4.41117 51.9147 9.6865V9.6865C53.1898 12.3242 55.8614 14 58.7911 14H71\" stroke-width=\"1.5\" /><circle cx=\"4\" cy=\"4\" r=\"3.25\" transform=\"matrix(1 0 0 -1 40 11.5527)\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol